import { Alert, Box, Button, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { date, dateTime } from '../../lib/format';
import { useTenantScope } from '../../store/selectors';
import DataTable from '../../ui/DataTable';
import { StatusChip } from '../../ui/primitives';
import ReportRunForm from './ReportRunForm';

export default function ReportRunsTab() {
  const scope = useTenantScope();
  const [creating, setCreating] = useState(false);
  const pending = scope.reportRuns.some((run) => run.status === 'PENDING_APPROVAL');
  if (creating) return <ReportRunForm onDone={() => setCreating(false)} />;
  return (
    <>
      {pending && (
        <Alert
          severity="warning"
          sx={{ mb: 2 }}
          action={
            <Button component={RouterLink} to="/manager/approvals" size="small">
              Approvals
            </Button>
          }
        >
          A report is waiting for a second person to approve it before anything is sent.
        </Alert>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 640 }}>
          One run per quarter: the shared report plus a statement for every investor, built from the
          register, approved once and delivered by email and in the app.
        </Typography>
        <Button variant="contained" onClick={() => setCreating(true)}>
          New quarterly report
        </Button>
      </Box>
      <Paper variant="outlined">
        <DataTable
          rows={scope.reportRuns}
          rowKey={(row) => row.id}
          dense
          emptyMessage="No quarterly reports sent from the platform yet"
          columns={[
            {
              key: 'title',
              label: 'Report',
              render: (row) => (
                <>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {row.title}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    As at {date(row.quarterEnd)} ·{' '}
                    {row.fundIds.map((id) => scope.fundById.get(id)?.code).join(', ')}
                  </Typography>
                </>
              ),
            },
            {
              key: 'investors',
              label: 'Investors',
              align: 'right',
              render: (row) => row.holderIds.length,
            },
            {
              key: 'delivery',
              label: 'Delivery',
              render: (row) => (row.delivery === 'APP_ONLY' ? 'App only' : 'Email and app'),
            },
            {
              key: 'by',
              label: 'Prepared / approved',
              render: (row) => `${row.createdBy}${row.approvedBy ? ` / ${row.approvedBy}` : ''}`,
            },
            { key: 'sent', label: 'Sent', render: (row) => dateTime(row.sentAt) },
            { key: 'status', label: 'Status', render: (row) => <StatusChip status={row.status} /> },
          ]}
        />
      </Paper>
    </>
  );
}
